// export const VIANUVEM_API_ENDPOINT = process.env.REACT_APP_VIANUVEM_API_ENDPOINT;
export const VIANUVEM_API_ENDPOINT = `${window.location.protocol}//${window.location.hostname}/AdminVianuvem`;
//export const VIANUVEM_API_ENDPOINT = `http://dev2.vianuvem.com.br/AdminVianuvem`;



// WEBPACK FOOTER //
// ./src/integrations/Defaults.js